import { create } from 'zustand';

/**
 * Animator Control — pont interne pour les COMMANDES DE JEU génériques envoyées
 * par le cockpit pendant une partie (ex. Unquiz : « question suivante » →
 * message `show-next`). Jumeau de useRemoteLaunch : ScreenApp lit le signal
 * `gameCommand` dans Firestore et pousse {name, nonce} ; useWebViewPlugin poste
 * le message `name` dans l'iframe. Chaque jeu écoute les commandes qu'il
 * comprend et ignore les autres.
 */
type RemoteGameCommandStore = {
    name: string | null;
    nonce: number | null;
    fire: (name: string, nonce: number) => void;
};

export const useRemoteGameCommand = create<RemoteGameCommandStore>((set) => ({
    name: null,
    nonce: null,
    fire: (name: string, nonce: number) => set({ name, nonce }),
}));
